import { Platform, ScrollView, View } from 'react-native';

import { DraggableScrollView } from 'components/ui/draggable-scrollview';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { UpsellSkeleton } from 'pages/cart/upsell/upsell.skeleton';
import { useAuthContext } from 'state/auth';
import { t } from 'state/intl/translations';

import { CartSectionHeader } from '../cart-section-header';
import { CartUpsellItem } from '../cart-upsell/cart-upsell-item';
import { useCartUpsellItems } from '../cart-upsell/use-cart-upsell-items';

const UpsellContent = () => {
  const upsellData = useCartUpsellItems();
  const isDesktop = useIsDesktopBreakpoint();
  const isDesktopWeb = isDesktop && Platform.OS === 'web';
  const ScrollViewComponent = isDesktopWeb ? DraggableScrollView : ScrollView;
  const renderedUpsellItems = upsellData.items.filter(
    (menuEntry): menuEntry is NonNullable<typeof upsellData.items[number]> => !!menuEntry
  );

  if (upsellData.loading) {
    return <UpsellSkeleton />;
  }
  if (!renderedUpsellItems.length) {
    return null;
  }
  return (
    <View style={{ gap: 16, marginTop: 10 }} testID="upsell">
      <CartSectionHeader title={t('addToOrderHeader')} testID="cart-section-heading-label" />
      <ScrollViewComponent horizontal showsHorizontalScrollIndicator={false}>
        {renderedUpsellItems.map((menuEntry, index) => (
          <CartUpsellItem key={menuEntry.id} menuEntry={menuEntry} position={index + 1} />
        ))}
      </ScrollViewComponent>
    </View>
  );
};

export const UpsellSection = () => {
  const { isAuthenticated } = useAuthContext();

  if (!isAuthenticated) {
    return null;
  }
  return <UpsellContent />;
};
